'use client';

import { Button } from '@savvy-kit/components/button';
import { cn } from '@savvy-kit/lib/utils';
import { Inbox } from 'lucide-react';

type TableEmptyStateProps = {
  readonly headerText?: string;
  readonly subheaderText?: string;
  readonly buttonText?: string;
  readonly onButtonClick?: () => void;
  readonly className?: string;
};

export function TableEmptyState({
  headerText = 'No data to show',
  subheaderText = "Try adjusting your search or filter to find what you're looking for",
  buttonText = 'Clear Filters',
  onButtonClick,
  className,
}: TableEmptyStateProps) {
  return (
    <div
      className={cn('flex min-h-[300px] flex-col items-center justify-center gap-4 p-6 text-center', className)}
      data-slot="table-empty-state"
    >
      <div className="flex size-12 items-center justify-center rounded-lg border border-light bg-primary-background">
        <Inbox className="size-6 text-primary" />
      </div>
      <div className="flex flex-col items-center gap-1">
        <h3 className="text-base font-semibold text-foreground">{headerText}</h3>
        <p className="max-w-md text-sm text-secondary">{subheaderText}</p>
      </div>
      {onButtonClick != null ? (
        <Button variant="default" size="sm" onClick={onButtonClick}>
          {buttonText}
        </Button>
      ) : null}
    </div>
  );
}

export default TableEmptyState;
